export const INVALID_TEAM = 'INVALID';
export const INVALID_ROLE = 'INVALID';
export const RETAILER_TEAM_CODE = 'BB_RT';
export const VENDOR_TEAM_CODE = 'BB_VT';
export const BEST_BUY_ROLE_CODE = 'R_BB';
export const DISNEY_ROLE_CODE = 'V_DIS';
export const LIONSGATE_ROLE_CODE = 'V_LIO';
export const MILL_CREEK_ROLE_CODE = 'V_MIL';
export const PARAMOUNT_ROLE_CODE = 'V_PAR';
export const SDS_ROLE_CODE = 'V_SDS';
export const SONY_ROLE_CODE = 'V_SON';
export const MASTER_ITEMS = 'MASTER_ITEMS';
export const CHILD_ITEMS = 'CHILD_ITEMS';
export const NEW_ITEM_PROMOTION_LIST = 'NEW_ITEM_PROMOTION_LIST';
export const NEW_ITEM_PROMOTION_DETAIL = 'NEW_ITEM_PROMOTION_DETAIL';
export const NEW_ITEM_PROMOTION_DETAIL_APROVAL = 'NEW_ITEM_PROMOTION_DETAIL_APROVAL';
export const NEW_ITEM_PROMOTION_FORECAST_APROVAL = 'NEW_ITEM_PROMOTION_FORECAST_APROVAL';
export const PROMOTION_PLANNER_LIST = 'PROMOTION_PLANNER_LIST';
export const PROMOTION_PLANNER_DETAIL = 'PROMOTION_PLANNER_DETAIL';
export const PROMOTION_PLANNER_FORECAST = 'PROMOTION_PLANNER_FORECAST';
